<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { FieldSchema } from '@FormModule';
import { capitalizeEachWord } from '@Helpers';

type DividerAlign = 'center' | 'left' | 'top' | 'bottom' | 'right';
type DividerLayout = 'vertical' | 'horizontal';
type DividerType = 'dashed' | 'dotted' | 'solid';

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  align?: DividerAlign;
  content?: string;
  contentClass?: string;
  field?: FieldSchema;
  layout?: DividerLayout;
  sectionTitle?: boolean;
  type?: DividerType;
}>();

const { t } = useI18n();

const title = computed(() => {
  const text = t(props.field?.settings?.content ?? props.content ?? '');

  return props.sectionTitle ? capitalizeEachWord(text) : text;
});
</script>

<template>
  <Divider
    :align="field?.settings?.align ?? align ?? (sectionTitle ? 'left' : 'center')"
    :class="['my-0', sectionTitle ? '!pl-0' : 'before:border-t-2']"
    :layout="field?.settings?.layout ?? layout ?? 'horizontal'"
    :pt:content:class="{ '!pl-0': sectionTitle }"
    :type="(field?.settings?.dividerType as DividerType) ?? type ?? (sectionTitle ? 'solid' : 'dashed')"
  >
    <span
      v-if="field?.settings?.content ?? content"
      :class="['font-semibold', contentClass ?? (sectionTitle ? 'text-base' : 'text-sm')]"
    >
      {{ title }}
    </span>
  </Divider>
</template>
